(function () {
  'use strict';

  function activateTab(modal, tab) {
    if (!modal || !tab) return;

    var tabs = modal.querySelectorAll('[role="tab"]');
    var panels = modal.querySelectorAll('[role="tabpanel"]');
    var talle = tab.getAttribute('data-talle');

    tabs.forEach(function (item) {
      var isActive = item === tab;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      item.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    panels.forEach(function (panel) {
      var isActive = panel.getAttribute('data-talle') === talle;
      panel.classList.toggle('is-active', isActive);
      if (isActive) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  }

  function initModal(modal) {
    if (!modal || modal.dataset.lopSizeGuideInit === 'true') return;
    modal.dataset.lopSizeGuideInit = 'true';

    modal.addEventListener('click', function (event) {
      var tab = event.target.closest('[role="tab"]');
      if (!tab || !modal.contains(tab)) return;
      activateTab(modal, tab);
    });

    modal.addEventListener('keydown', function (event) {
      var tab = event.target.closest('[role="tab"]');
      if (!tab || !modal.contains(tab)) return;

      var tabs = Array.prototype.slice.call(modal.querySelectorAll('[role="tab"]'));
      var index = tabs.indexOf(tab);
      if (index === -1) return;

      var nextIndex = index;

      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        event.preventDefault();
        nextIndex = (index + 1) % tabs.length;
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        event.preventDefault();
        nextIndex = (index - 1 + tabs.length) % tabs.length;
      } else if (event.key === 'Home') {
        event.preventDefault();
        nextIndex = 0;
      } else if (event.key === 'End') {
        event.preventDefault();
        nextIndex = tabs.length - 1;
      } else {
        return;
      }

      var nextTab = tabs[nextIndex];
      if (!nextTab) return;
      nextTab.focus();
      activateTab(modal, nextTab);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-lop-size-guide-modal]').forEach(initModal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
